// pages/HomePage.jsx - Home page with feature list and assets
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

// Import assets
import mainLogo from './assets/logos/logo.png';
import advofinder from './assets/logos/advofinder.png';
import advoconnect from './assets/logos/advoconnect.png';
import advoplanner from './assets/logos/advoplanner.png';
import aiAlly from './assets/logos/aially.png';
import advointern from './assets/logos/advointern.png';

const HomePage = () => {
  const navigate = useNavigate();
  
  // Feature data with structure for easy mapping
  const features = [
    {
      id: 'advofinder',
      name: 'AdvoFinder',
      logo: advofinder,
      description: 'Verified Law Firm Discovery',
      color: 'advofinder-gradient'
    },
    {
      id: 'advoconnect',
      name: 'AdvoConnect',
      logo: advoconnect,
      description: 'Private Legal Community & Mentorship',
      color: 'advoconnect-gradient'
    },
    {
      id: 'advoplanner',
      name: 'AdvoPlanner',
      logo: advoplanner,
      description: 'Smart Legal Productivity Toolkit',
      color: 'advoplanner-gradient'
    },
    {
      id: 'aiAlly',
      name: 'AiAlly',
      logo: aiAlly,
      description: 'Al-Powered Research & Drafting Help',
      color: 'aiAlly-gradient'
    },
    {
      id: 'advointern',
      name: 'AdvoIntern',
      logo: advointern,
      description: 'Internship & Legal Gig Opportunities',
      color: 'advointern-gradient'
    }
  ];

  const handleKnowMore = (featureId) => {
    navigate(`/feature/${featureId}`);
  };

  return (
    <div className="home-container">
      {/* Background is applied via CSS using the background image */}
      
      {/* Logo and Header */}
      <div className="header-section">
        <div className="app-logo">
          <img src={mainLogo} alt="AdvoAI Logo" className="logo-image" />
        </div>
        <h1 className="app-title">AdvoAI</h1>
        <h1 className="app-tagline">India's First Verified<br/>
        LegalTech Ecosystem</h1>
        <br/>
        <p className="app-tagline">
          Your Legal Ally
          Anytime, Anywhere.
        </p>
        <div className="section-divider"></div>
        
        <div className="app-description">
          <p>
            AdvoAI is a compliance-first legal platform
            designed for law students, law firms, and
            the public. It enables access to verified
            legal discovery, internships, mentorship,
            Al assistance-and smart productivity - all
            built with Bar Council of India (BCI)
            guidelines in mind.
          </p>
        </div>
      </div>
      
      {/* Features Section */}
      <div className="features-section">
        <h2 className="features-title">
          <span>Features</span>
        </h2>
        
        <div className="feature-list">
          {features.map((feature) => (
            <div key={feature.id} className="feature-item">
              <div className={`feature-icon ${feature.color}`}>
                <img 
                  src={feature.logo} 
                  alt={`${feature.name} Logo`}
                  className="feature-logo-image" 
                />
              </div>
              <div className="feature-content">
                <h3 className="feature-name">{feature.name}</h3>
                <p className="feature-description">{feature.description}</p>
                <button 
                  onClick={() => handleKnowMore(feature.id)} 
                  className="know-more-link"
                >
                  Know more
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Footer */}
      <div className="footer-section">
        <div className="section-divider"></div>
        <div className="company-info">
          <p className="made-in">
            Proudly made in India 🇮🇳<br />
            100% Safe and Secure
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;